// Quote-only region gating.
// ceo_instruction_ref: kenya_cart_gating_quote_only_24jul2026
// CEO ruling: some regions (Kenya today) are QUOTE-ONLY — the only
// permitted order route is quote → CEO authorise → convert to
// kenya_orders. Distributors in these regions must never see or
// reach the cart. Add a region code here and every gate (header
// icon, sidebar entry, /dashboard/cart route, add-to-cart
// affordances, CartContext.addItem) inherits it with no further
// build. Backend order guards remain the last line of defence.
export const QUOTE_ONLY_REGIONS = ['kenya'];

export const isQuoteOnlyDistributor = (user) =>
  user?.role === 'distributor' &&
  QUOTE_ONLY_REGIONS.includes((user?.region || '').toLowerCase());
